import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmrReadyProviderPageRoutingModule } from './emr-ready-provider-routing.module';

import { EmrReadyProviderPage } from './emr-ready-provider.page';
import { SharedComponentsModule } from 'src/app/shared/modules/shared-components/shared-components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedComponentsModule,
    EmrReadyProviderPageRoutingModule
  ],
  declarations: [EmrReadyProviderPage]
})
export class EmrReadyProviderPageModule {}
